/**
 * Instead of enum types for ResultType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */

export var Scope = /*#__PURE__*/function (Scope) {
  Scope["JiraIssue"] = "jira.issue";
  Scope["JiraPlan"] = "jira.plan";
  Scope["JiraBoardProjectFilter"] = "jira.board,project,filter";
  Scope["JiraBoardProjectFilterPlan"] = "jira.board,project,filter,plan";
  Scope["JiraProject"] = "jira.project";
  Scope["People"] = "urs.user-jira";
  return Scope;
}({});

/**
 * Identifier type used in `Result.contentType`.
 */
export var ContentType = /*#__PURE__*/function (ContentType) {
  ContentType["JiraIssue"] = "jira-issue";
  ContentType["JiraBoard"] = "jira-board";
  ContentType["JiraProject"] = "jira-project";
  ContentType["JiraFilter"] = "jira-filter";
  ContentType["JiraPlan"] = "jira-plan";
  ContentType["JiraPeople"] = "jira-people";
  return ContentType;
}({});

// RESPONSES FOR ALL SCOPES

export function isSingleAvatar(avatar) {
  return Object.prototype.hasOwnProperty.call(avatar, 'url');
}
export function isMultipleAvatar(avatar) {
  return Object.prototype.hasOwnProperty.call(avatar, 'urls');
}
export var AttributeType = /*#__PURE__*/function (AttributeType) {
  AttributeType["issue"] = "issue";
  AttributeType["board"] = "board";
  AttributeType["project"] = "project";
  AttributeType["filter"] = "filter";
  AttributeType["plan"] = "plan";
  AttributeType["people"] = "people";
  return AttributeType;
}({});

/**
 * The shape of the response from the XP search endpoint.
 */

/**
 * A single transformed result from the XP search endpoint.
 */

/**
 * The shape of the transformed results from the XP search endpoint.
 * Each result is collated under the `items` property.
 */